// extracted by mini-css-extract-plugin
export default {"icon":"common-components-AccountCardIcon-AccountCardIcon__icon--mqeIJ"};